import {
  Component,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  inject,
} from '@angular/core';

import { ExportHelpers } from '../../services/export-helper/export-helper.service';

@Component({
  selector: 'phoenix-img-actions',
  template: ` <div
    class="flex-none h-auto relative flex flex-row items-center  py-2 px-4"
    [ngClass]="{
      'justify-center': centerDivs,
      'justify-between': !centerDivs,
    }"
  >
    <!-- Left div -->
    <div
      class="flex items-center self-center gap-2"
      [ngClass]="centerDivs ? 'justify-center' : 'justify-start w-1/4'"
    >
      @if (uploadButton) {
        <phoenix-upload-image
          [showMedia]="false"
          (imageList)="uploadImgs($event)"
        ></phoenix-upload-image>
      }
    </div>

    <!-- Right div -->
    <div
      class="flex items-center gap-2"
      [ngClass]="centerDivs ? 'justify-center' : 'justify-end ml-auto w-1/4'"
    >
      @if (zoomImg) {
        <mat-slider
          [max]="100"
          [min]="0"
          [discrete]="true"
          [showTickMarks]="true"
          [step]="10"
        >
          <input
            matSliderThumb
            [(ngModel)]="boxExtraSize"
            (ngModelChange)="boxExtraSizeChange.emit(boxExtraSize)"
            #slider
          />
        </mat-slider>
      }
      <a
        mat-icon-button
        class="material-icons-outlined"
        [href]="img"
        target="_blank"
        rel="noopener noreferrer"
        matTooltip="Open in a separate tab"
      >
        zoom_out_map
      </a>

      @if (imgDownload) {
        <button
          mat-icon-button
          color="primary"
          class="material-icons-outlined"
          (click)="downloadImg()"
          matTooltip="Download Image"
        >
          cloud_download
        </button>
      }
    </div>
  </div>`,
  standalone: false,
})
export class ImgActionsComponent {
  @Input() zoomImg = true;
  @Input() img!: string;
  @Input() imgDownload!: string;
  @Input() uploadButton = false;
  @Input() boxExtraSize = 0;
  @Input() centerDivs = false;

  @Output() selectedFile = new EventEmitter<File[]>();
  @Output() boxExtraSizeChange = new EventEmitter<number>();

  render = inject(Renderer2);

  downloadImg() {
    ExportHelpers.downloadLink(this.render, this.imgDownload);
  }

  uploadImgs(imgs: File[]) {
    this.selectedFile.emit(imgs);
  }
}
